import { createContext } from 'react';

export const MapContext = createContext(null);

export default MapContext;
